import React from 'react';

import SomethingWentWrong from '../../something-went-wrong.svg';
import styles from './ChartError.module.scss';

export interface ChartErrorLocales {
  imgAlt: string;
  title: string;
  description: string;
  linkAlt: string;
}

export interface ChartErrorProps {
  supportEmail: string;
  locales: ChartErrorLocales;
}

export const ChartError = ({ supportEmail, locales }: ChartErrorProps) => {
  return (
    <div className={styles.chartErrorRoot} data-testid="chart-error">
      <SomethingWentWrong className={styles.errorImage} alt={locales.imgAlt} />
      <div className={styles.title}>{locales.title}</div>
      <div className={styles.description}>
        {locales.description}
        <a
          className={styles.link}
          title={locales.linkAlt}
          href={`mailto:${supportEmail}`}
        >
          {supportEmail}
        </a>
      </div>
    </div>
  );
};
